<template>
  <div class="rightLayoutWrap1">
    <div class="height100pScrollWrap">
      <imageCall :modesTaskData="edocPop.modesTaskData" v-if="edocPop.modesTaskData"></imageCall>
      <div v-else>加载中...</div>
    </div>
  </div>
</template>
<script>
import apiAxios from '@/apiAxios.js'
import imageCall from '@/compSys/edoc/imageCall/imageCall.vue'
export default {
  components: { imageCall },
  data() {
    return {
      edocPop: {
        title: '',
        isVisible: false,
        modesTaskData: null,
      },
    }
  },
  watch: {
    $route(to, from) {
      this.ViewMedia()
    },
  },
  props: {
    edocNo: {
      type: String,
      required: true,
    },
  },
  computed: {},
  methods: {
    async ViewMedia() {
      this.edocPop.modesTaskData = null
      const { data } = await apiAxios.post(
        `/edoc/edocHeaderFacade/edocHeaderCheck`,
        {
          token: store.get('onlyToken'),
          edocNo: this.edocNo,
          // edocNo: 'FY201812011130LeonTEST16',
          limit: 10,
          page: 1,
        }
      )
      if (!data.success) {
        return this.$alert(data.msg)
      }
      if (data.result.totalRows) {
        const row = data.result.dataGrid[0]
        this.edocPop.modesTaskData = {
          bizCode: row.edocNo,
          bizName: row.edocType,
          coverId: row.id + '',
        }
        this.edocPop.isVisible = true
      } else {
        this.edocPop.modesTaskData = null
        this.$alert('没有影像件')
      }
    },
  },
  async mounted() {
    await this.ViewMedia()
  },
}
</script>
<style scoped lang="scss">
</style>
